import React from 'react';

const Footer: React.FC = () => {
  const handleContact = (e: React.MouseEvent) => {
      e.preventDefault();
      // Dynamic construction to foil scrapers
      window.location.href = `mailto:${'info'}@${'edgarcayce.ch'}`;
  };

  return (
    <footer className="bg-[#1e2a4a] text-white/80 py-12 px-6 border-t border-white/10 relative z-20">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
        <div className="text-center md:text-left">
          <h4 className="font-serif text-2xl text-[#ed9f3d] mb-3">Edgar Cayce Chronicles</h4>
          <p className="text-xs max-w-sm text-white/60 leading-relaxed mx-auto md:mx-0">
            A digital preservation initiative dedicated to indexing, analyzing, and sharing the complete readings of the Sleeping Prophet for the modern era.
          </p>
        </div>
        
        <div className="flex flex-col items-center md:items-end gap-3">
          <a 
            href="#"
            onClick={handleContact}
            className="group flex items-center gap-3 px-5 py-2 rounded-full bg-white/5 hover:bg-[#ed9f3d]/10 border border-white/10 hover:border-[#ed9f3d]/50 transition-all duration-300"
          >
            <div className="w-8 h-8 rounded-full bg-[#ed9f3d] text-[#1e2a4a] flex items-center justify-center text-sm">
                <i className="fa-regular fa-envelope"></i>
            </div>
            <span className="text-sm font-bold text-white group-hover:text-[#ed9f3d] transition-colors">
                Contact Administration
            </span>
          </a>
          <p className="text-[10px] uppercase tracking-widest text-white/30 mt-2">
            © {new Date().getFullYear()} Non-Profit Research Archive
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;